import classNames from 'classnames';

import { useMBDContext } from '../common/MBD/useMBDContext';

import type { TrustpilotReviewsProps } from '@skyscanner-internal/landing-pages-shared-types/types-shared/TrustpilotReviewsProps';

import STYLES from './TrustpilotReviews.module.scss';

const TrustpilotReviews = (props: TrustpilotReviewsProps) => {
  const {
    reviewsCount,
    starsImageAltText,
    starsImageUrl,
    trustpilotLogoAltText,
    trustpilotLogoImageUrl,
    trustpilotUrl,
  } = props;

  const reduceTopMargin = true; // can be configured in LPP in the future

  const { buildMBDParam, rawComponentName } = useMBDContext();
  const mbdComponentName = rawComponentName;

  return (
    <div
      className={classNames(STYLES.TrustpilotReviews, {
        [STYLES.TrustpilotReviewsReducedTopMargin]: reduceTopMargin,
      })}
      data-testid="trustpilotReviews"
      data-tracking-element-id={mbdComponentName}
      data-tracking-common-params={buildMBDParam(mbdComponentName)}
    >
      <a
        href={trustpilotUrl}
        target="_blank"
        rel="noreferrer nofollow"
        data-tracking-element-id={`${mbdComponentName}_link`}
        data-tracking-common-params={buildMBDParam(`${mbdComponentName}_link`)}
      >
        <img
          className={STYLES.TrustpilotReviewsStars}
          height="26"
          src={starsImageUrl}
          alt={starsImageAltText}
        />{' '}
        <span className={STYLES.TrustpilotReviewsCount}>{reviewsCount} </span>
        <img
          className={STYLES.TrustpilotReviewsLogo}
          height="26"
          src={trustpilotLogoImageUrl}
          alt={trustpilotLogoAltText}
        />
      </a>
    </div>
  );
};

export default TrustpilotReviews;
